export default __webpack_public_path__ + "static/media/createTeamGray.20d537e7.svg";